
import userProfileBroken from '@/assets/images/user-profile-broken.png'

/**
 *
 *
 *
 */

export const processUserPhone = userProfile => {
  const ddd = !!userProfile.ddd === true ? String(userProfile.ddd).trim() : ''
  const phone = !!userProfile.tel === true ? String(userProfile.tel).trim() : ''

  return ddd.length === 2 && (phone.length === 8 || phone.length === 9) ? ('(' + ddd + ') ' + (phone.length === 8 ? phone.replace(/(\d{4})(\d{4})/, '$1-$2') : phone.replace(/(\d{5})(\d{4})/, '$1-$2'))) : ''
}

export const isValidImage = img => !!img === true && typeof img === 'string' && img.indexOf('https://firebasestorage.googleapis.com/') !== -1

export const isValidCPF = value => {
  if (!value) {
    return false
  }

  value = value.replace(/[^0-9]/g, '')

  var Soma
  var Resto
  Soma = 0

  if (value === '00000000000') {
    return false
  }

  for (let i = 1; i <= 9; i++) {
    Soma = Soma + parseInt(value.substring(i - 1, i)) * (11 - i)
  }

  Resto = (Soma * 10) % 11

  if (Resto === 10 || Resto === 11) {
    Resto = 0
  }

  if (Resto !== parseInt(value.substring(9, 10))) {
    return false
  }

  Soma = 0

  for (let i = 1; i <= 10; i++) {
    Soma = Soma + parseInt(value.substring(i - 1, i)) * (12 - i)
  }

  Resto = (Soma * 10) % 11

  if (Resto === 10 || Resto === 11) {
    Resto = 0
  }

  if (Resto !== parseInt(value.substring(10, 11))) {
    return false
  }

  return true
}

export const isValidEmail = email => !!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(email)

const processUserCpf = user => {
  let cpf = ''
  try {
    cpf = !!user.cpf === true ? String(user.cpf).replace(/[^0-9]/g, '') : ''
  } catch (userError) {
    cpf = ''
    // [24/01/25] console.log('ERRO NO USUÁRIO:', user, userError) // userDetails.uid
  }
  return cpf
}

export const processUserProfile = user => {
  const img = user.img && typeof user.img === 'string' && user.img.indexOf('https://firebasestorage.googleapis.com/') !== -1 ? String(user.img) : userProfileBroken

  const userName = !!user.nome === true ? String(user.nome).trim() : ''
  const userNameAbrev = !!user.nome === true ? nomeAbrev(user.nome) : ''

  const ddd = !!user.ddd === true ? String(user.ddd).trim() : ''
  const phone = !!user.tel === true ? String(user.tel).trim() : ''
  const telefone = ddd.length === 2 && (phone.length === 8 || phone.length === 9) ? ('(' + ddd + ') ' + (phone.length === 8 ? phone.replace(/(\d{4})(\d{4})/, '$1-$2') : phone.replace(/(\d{5})(\d{4})/, '$1-$2'))) : ''

  let cpf = processUserCpf(user)
  cpf = cpf.length === 11 ? cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})*/, '$1.$2.$3-$4') : '' // SENHOR JESUS

  const email = !!user.email === true ? String(user.email).trim() : ''
  const crm = !!user.crm === true ? String(user.crm).trim() : ''
  const conta = !!user.conta === true ? String(user.conta).trim() : ''

  return { email, userName, userNameAbrev, img, crm, cpf, ddd, telefone, conta }
}

export const processGroupUserProfile = (groupID, userID, /* currentID, */ user, group) => {
  if (!!user === false) return false

  const userName = !!user.nome === true && String(user.nome).trim().length > 0 ? String(user.nome).trim() : ''
  const userFistName = userName ? primeiroNome(userName) : ''
  const userFirstLastName = userName ? firstLastName(userName) : ''
  const userNameAbrev = userName ? nomeAbrev(userName) : ''

  const userPhone = processUserPhone(user)

  let userCpf = processUserCpf(user)
  userCpf = userCpf.length === 11 ? userCpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})*/, '$1.$2.$3-$4') : ''

  //
  // VALOR HORA NO GRUPO
  //

  // const value = typeof valueDecimal === 'string' ? parseFloat(valueDecimal) : valueDecimal

  // JESUS: Bug aqui?
  const hourlyRate = !!user.grupos === true && !!user.grupos[groupID] === true && !!user.grupos[groupID].hourlyrate === true ? parseFloat(user.grupos[groupID].hourlyrate) : 0
  const groupHourlyRate = hourlyRate === 0 ? '' : hourlyRate.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' })

  const userMunicipalities = !!group.users[userID] === true && !!group.users[userID].municipalities === true ? group.users[userID].municipalities : null

  //
  // OUTPUT
  //

  return {
    backup: user,
    ...user,
    userID,
    // isMe: userID === currentID,
    userImage: isValidImage(user.img || '') ? String(user.img).trim() : userProfileBroken,
    userImageIsValid: isValidImage(user.img || ''),
    userFistName,
    userFirstLastName,
    userNameAbrev,
    userName,
    userEmail: user.email || '',
    userPhone,
    userCpf,
    userCrm: user.crm || '',
    userMunicipalities,
    groupHourlyRate,

    isMunicipality: !!group.users[userID] === true && !!group.users[userID].municipality === true,
    // isMunicipality: !!group.users[userID] === true ? (group.users[userID].municipality || false) : false,

    isAdmin: !!group.users[userID] === true && !!group.users[userID].admin === true,
    isMaster: !!group.users[userID] === true && !!group.users[userID].master === true,
  }
}

export const nomeAbrev = $nometodo => {
  const $nome = $nometodo.trim().replace(/ de | do | dos | da | das | e /i, ' ').split(' ')

  // console.log('nomeAbrev[nome]:', $nome)

  if ($nome.length < 2) {
    return $nometodo.length > 16 ? `${$nometodo.substr(0, 16)}...` : $nometodo.trim()
  } else {
    let $nomesMeio = ' '

    for (let $x = 1; $x < $nome.length; $x++) {
      $nomesMeio += $nome[$x].length <= 4 || ($nome[0].length <= 4 && $x === 1) ? ($nome[$x] + ' ') : ($nome[$x].charAt(0).toUpperCase() + '. ')
    }

    // console.log('nomeAbrev[nomesMeio]:', $nomesMeio)

    const saida = $nome[0].length <= 4 ? ($nome[0] + $nomesMeio) : ($nome.shift() + $nomesMeio)

    return saida.trim()
  }
}

export const primeiroNome = nomeCompleto => {
  const $nome = nomeCompleto.split(' ')[0]
  return $nome
}

export const firstLastName = nomeCompleto => {
  const nameWords = nomeCompleto.split(' ')

  let nome = nomeCompleto

  if (nameWords.length === 1) {
    nome = nameWords[0]
  } else if (nameWords.length > 1) {
    nome = nameWords[0] + ' ' + nameWords[nameWords.length - 1]
  }

  return nome
}

/**
 *
 *
 *
 */

/* const durationToFactor = (duration = '00:00') => {
  const isNumber = typeof duration === 'number' && !isNaN(duration)
  const isInteger = isNumber && Number.isInteger(duration)
  const isFloat = isNumber && !isInteger

  if (isInteger) {
    return duration
  } else if (isFloat) {
    return duration
  } else if (typeof duration === 'string' && /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(duration)) {
    const explodedDuration = duration.split(':')

    const hours = parseInt(explodedDuration[0])
    const minutes = parseInt(explodedDuration[1])

    // parseFloat(explodedDuration[1]) === 0

    if (minutes === 0) {
      // EXEMPLOS: 00:00 ou 01:00
      return hours
    } else {
      // EXEMPLOS: 00:30 ou 01:30
      // return parseFloat(factor).toFixed(2)
      return (hours + (minutes / 60)).toFixed(3)
    }
  } else if (typeof duration === 'string' && /^([0-1]?[0-9]|2[0-3])$/.test(duration)) {
    // console.log('::: DURATION TO FACTOR:', duration)

    return parseInt(duration)
  } else {
    return 0
  }
} */

/* export {
  // durationToFactor,
} */
